import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "सौ.माधुरी नंदगोपाल सोमकुवर ", designation: "गट ग्रामपंचायत सोनेगाव  ", phone: "+91 9579853120", imageUrl: "/images/femal.png" },
  { name: "श्री. दिनेश हरिमोहन झोशी", designation: "गट ग्रामपंचायत सोनेगाव ", phone: "+91 9823159075", imageUrl: "/images/men.png" },
  { name: "श्री. शुद्धधन ज्ञानदेव पाटील", designation: "गट ग्रामपंचायत सोनेगाव ", phone: "+91 9284074946", imageUrl: "/images/femal.png" },
  { name: "सौ. विनिता कडू राव", designation: "गट ग्रामपंचायत सोनेगाव ", phone: "+91 7666510161", imageUrl: "/images/femal.png" },
  { name: "सौ. माधुरी अशोक गायकवाड", designation: " गट ग्रामपंचायत सोनेगाव  ", phone: "+91 9637382467", imageUrl: "/images/femal.png" },
  { name: "श्री. शरद मुरलीधर ठाकरे", designation: "गट ग्रामपंचायत सोनेगाव ", phone: "+91 9049166852", imageUrl: "/images/men.png" },
  { name: "श्री. ओमप्रकाश मुलचंद वरठे", designation: "गट ग्रामपंचायत सोनेगाव ", phone: "+91 8767468955", imageUrl: "/images/men.png" },
  

];

const karmachariMembers = [
  { name: " --  ", designation: "सफाई  कर्मचारी", imageUrl: "/images/men.png" },
  { name: "--  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/men.png" },
  { name: "--", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/men.png" },
  { name: "--", designation: "संगणक परिचालक", imageUrl: "/images/men.png" },
  { name: "--", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/men.png" },
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">कर्मचारी</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
